import { render, staticRenderFns } from "./TituloListAddNew.vue?vue&type=template&id=5cec3d61&"
import script from "./TituloListAddNew.vue?vue&type=script&lang=js&"
export * from "./TituloListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TituloListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports